<template>
    <div id="tableau">
    </div>
</template>

<script>
export default {
    name: 'Tableau',
    props: {
        url: '',
        options: {},
        width: '',
        height: '',
        filters: {},
        // apiUrl: {
        //     // default: 'https://public.tableau.com/javascripts/api/tableau-2.2.2.min.js'
        //     default: ''
        // }
    },
    data () {
        return {
            viz: {},
            workBook: {}
        }
    },
    watch: {
        url () {
            if (this.viz) {
        console.log('---------------------------------url-------------------------------')
        this.viz.dispose()
            }
            this.initViz()
        },
        height (val) {
            this.viz.setFrameSize(parseInt(this.width), parseInt(val))
        },
        width (val) {
            this.viz.setFrameSize(parseInt(val), parseInt(this.height))
        },
        filters () {
            if (this.viz) {
        console.log('---------------------------------filters-------------------------------')
        this.viz.dispose()
            }
            this.initViz()
        }
    },
    computed: {
        worksheet () {
            return this.workBook.getActiveSheet()
        }
    },
    methods: {
        initViz () {
            const containerDiv = document.getElementById("tableau")
            // Setting up constructor options
            let options = {}
            if (!this.options) {
                console.log(this.width,this.height)
                options = {
                    height: this.height ? this.height : 1000,
                    width: this.width ? this.width : 1000,
                    hideTabs: true,
                    hideToolbar: true,
                    onFirstInteractive: () => { this.workBook = this.viz.getWorkbook() }
                }
                if (this.filters) {
                    Object.keys(this.filters).map((el) => {
                        options[el.toString()] = this.filters[el.toString()]
                    })
                }
            } else {
                options = this.options
            }
            this.viz = new window.tableau.Viz(containerDiv, this.url, options)
        }
    },
    mounted () {
        // let recaptchaScript = document.createElement('script')
        // // recaptchaScript.async = true
        // recaptchaScript.setAttribute('src', this.apiUrl)
        // this.tableauScript = document.head.appendChild(recaptchaScript)

        // window.addEventListener('load', () => {
        //     this.initViz()
        // })
        this.initViz()
    },
    beforeDestroy () {
        console.log('---------------------------------beforeDestroy-------------------------------')
        this.viz.dispose()
    }
}
</script>
<style lang="less" scoped>
#tableau{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// Tableau.vue?60eddd64